import { isVerticalTrace } from "./orientationSources";

const SIDE_LABEL = { left: "Left", right: "Right", center: "Center" };

/**
 * Inputs-table cells for the known point on face `n` of a face-log trace:
 * the face's chainage and the point's side, offset and height. A vertical
 * trace has no measured height; it is anchored at the invert, as the
 * plotting anchor for Face-1 is.
 */
export function faceLogPointRow(dimension, n) {
  const side = dimension[`fside${n}`];
  const cell = (v) => (v === undefined || v === null || v === "" ? "-" : String(v));
  return {
    ch: cell(dimension[`fch${n}`]),
    surface: `Face-${n}`,
    side: SIDE_LABEL[side] || "-",
    dist: side === "center" ? "0" : cell(dimension[`fd${n}`]),
    ht: isVerticalTrace(dimension.fappdip) ? "0" : cell(dimension[`fh${n}`]),
  };
}
